<div *ngIf="isManutenzione" class="maintenance-banner">
  <span class="dot">•</span><strong>{{ messaggio }}</strong>
  <span>{{ this.formatDataInizio.giorno }} alle ore {{ this.formatDataInizio.ora }} </span>
</div>
